<template>
  <div>
    <div class="bacgk">
      <div class="titile titile_flex">
        <h4 class="">相关需求</h4>
        <p @click="search">
          <i class="el-icon-refresh"></i>
          换一批
        </p>
      </div>
      <div class="right">
        <div class="right_box" v-for="(item, index) in demandList" :key="index">
          <a
              href="javascript:void(0)"
              @click="getDetailMessage(item.id)"
              style="color: #157efb"
          >
            <p class="right_box_title ellipsis-1" >{{ item.demandName }}</p></a
          >
          <p>{{ item.buyer }}</p>
          <p>需求类型：{{ item.demandTypeCn }}</p>
          <p>
            截止日期： <span>{{ item.deadline }}</span>
          </p>
          <p>
            投标数量： <span>{{ item.offerNum }}</span> 个
          </p>
          <p>
            <i class="el-icon-location" style="color: #000"></i>
            {{ item.addCity }}
          </p>
        </div>
      </div>
    </div>
    <!--    <div class="bacgk" style="margin-top: 15px">
      <div class="titile titile_flex">
        <h4 class="">买家推荐</h4>
        <p>
          换一批
          <i class="el-icon-refresh"></i>
        </p>
      </div>
      <div>
        <div
          class="corporation_box"
          v-for="(item, index) in corporationList"
          :key="index"
        >
          <img src="" alt="" />
          <div>
            <p class="corporation_box_title">{{ item.title }}</p>
            <p class="grap">
              <i class="el-icon-location"></i> {{ item.address }}
            </p>
            <p>
              相关需求： <span class="red">{{ item.nums }}</span> 个
            </p>
            <p>
              好评率： <span class="red">{{ item.nums }}</span> %
            </p>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import {
  getDemandsByPage,
  getNewcurrent,
  reportOffer,
} from "../../../../utils/interface";

export default {
  data() {
    return {
      id: "",
      classifyOneUuid: "",
      classifyTwoUuid: "",
      buyerUuid: "",
      currentPage: 1,
      currentSize: 4,
      demandList: [],
      corporationList: [
        {
          title: "风电、水电、船舶冶金等重型设备加工制造",
          corporation: "大连金宏机械制造有限公司",
          demand: "铸件加工",
          date: "2023-10-12",
          nums: "0",
          address: "大连市",
        },
      ],
    };
  },
  methods: {
    init(demandId, classifyOneUuid, classifyTwoUuid, buyerUuid) {
      this.id = demandId;
      this.classifyOneUuid = classifyOneUuid;
      this.classifyTwoUuid = classifyTwoUuid;
      this.buyerUuid = buyerUuid;
      this.search();
    },
    search() {console.log(this.classifyOneUuid)
      let params = {
        orderId: this.id,
        classifyOneUuid: this.classifyOneUuid,
        // classifyTwoUuid: this.classifyTwoUuid,
        currentPage: this.currentPage,
        pageSize: this.currentSize,
      };
      getDemandsByPage(params).then((res) => {
        let pages = 0;
        if (res != null && Number(res.data.total) > 0) {
          pages = Math.ceil(Number(res.data.total) / 4);
          if (this.currentPage <= pages - 1) {
            this.currentPage = this.currentPage + 1;
          } else {
            this.currentPage = 1;
          }
        }
        this.demandList = res.data.records;
      });
    },
    getDetailMessage(uuid) {
      let routeData = this.$router.resolve({
        path: `/demandDetails?uuid=${uuid}`,
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/index.less";
.bacgk {
  padding: 0;
}

.titile_flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 20px 20px 0 20px;
  margin-bottom: 0;
  p {
    font-size: 12px;
    cursor: pointer;
    color: #169999;
  }
  h4 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    border: none;
  }
}
.grap {
  color: rgba(0, 0, 0, 0.5);
}
.right {
  .right_box {
    color: #333;
    font-size: 14px;
    border-bottom: 1px solid #E8E8E8;
    padding: 20px;
    padding-top: 6px;
    p {
      margin-top: 10px;
    }
    .right_box_title {
      margin-bottom: 14px;
      font-weight: bold;
      color: #333333;
    }
    p {
      font-weight: 400;
      color: #999999;
    }
  }
}
.corporation_box {
  display: flex;
  font-size: 12px;
  padding-bottom: 15px;
  border-bottom: 1px solid #E8E8E8;
  cursor: pointer;
  img {
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    margin-right: 15px;
  }

  p {
    margin-bottom: 8px;
  }
  .corporation_box_title {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 8px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/details/demandDetailsRight.vue